import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Subscription from "./Pages/Plan/subscription";
import Plan_selection from "./Pages/Plan/PlanSelection";
import Success from "./Components/Success";
import Cancelled from "./Components/Cancelled";
import Register from "./Pages/Registration/Registration";
import Login from "./Pages/Login/Login";
import ForgotPassword from "./Pages/Password/ForgotPassword";
import UpdatePassword from "./Pages/Password/UpdatePassword";
import { AuthProvider } from "./SessionManagement/AuthContext";
import Navbar from "./Components/Navbar";
import NavbarHome from "./NavbarS/navbarJ";
import ProtectedRoute from "./SessionManagement/ProtectedRoutes";
import Dashboard from "./Pages/Dashboard/Dashboard";
import SessionNotesForm from "./Pages/SessionNote/SessionNotes";
import { SnackbarProvider } from "./Providers/SnackbarProvider";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ClientDataMain from "./Client/ClientMain";
import HtmlLoader from "./Components/HtmlLoader";
import SubscriberDashboard from "./Pages/SubscriberDashboard";
import DashboardTemplate from "./DashboardTemplate";
import ManageSessionNote from "./Pages/SessionNote/ViewSessionNote";
import InvoiceTable from "./Pages/Invoice";
import AllEmail from "./Admin/AllEmail";
import AddSubscriber from "./Admin/AllEmail/AddSubscriber";
import ManageSubscriber from "./Admin/AllEmail/ManageSubscriber";
import SubscriberClient from "./Admin/SubscriberClient";
import InvoiceAdmin from "./Admin/InvoiceAdmin";
import SupportPage from "./Admin/SupportPage";
import FeedbackPage from "./Admin/FeedbackPage/Index";
import MainPage from "./Pages/SessionNote/MainPageSessionNotes/Mainpage";
import SessionNote97151 from "./Pages/SessionNote97151/SessionNoteForm";
import SessionNote97153 from "./Pages/SessionNote/SessionNotes";
import SessionNote97155 from "./Pages/SessionNote97155/SessionNoteForm";
import SessionNote97156 from "./Pages/SessionNote97156/SessionNoteForm";
import SessionNoteH0032 from "./Pages/SessionNoteH0032/SessionNoteForm";
import Footer from "./NavbarS/footer";
import Keywords from "./Admin/AddKeywords/Index";
import { Snackbar, Alert } from "@mui/material";
import ManagePassword from "./Pages/ManagePassword";
import ResetPassword from "./Pages/ManagePassword/ResetPassword";
import PasswordResetOptions from "./Pages/Login/PasswordResetOptions";
// import AdminSessionNote from "./Admin/AdminSessionNote";
// import GetEmail from "./AllEmail/GetEmail";

// import Settings from "./components/Settings";

function App() {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  
  useEffect(() => {
    const clearLocalStorageIfExpired = () => {
      const lastLoginTime = localStorage.getItem("lastLoginTime");
      if (lastLoginTime) {
        const now = new Date();
        const lastLoginDate = new Date(lastLoginTime);
        const differenceInHours = (now - lastLoginDate) / 1000 / 60 / 60;

        if (differenceInHours >= 24) {
          localStorage.clear();
          setSnackbarMessage("Session expired, please log in");
          setSnackbarOpen(true);
          setTimeout(() => {
            window.location.href = "/login";
          }, 3000); // Redirect after 3 seconds
        }
      }
    };

    // Initial check
    clearLocalStorageIfExpired();

    // Set up interval to check every minute
    const intervalId = setInterval(clearLocalStorageIfExpired, 60000);

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <AuthProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <SnackbarProvider>
          <Router>
            <ConditionalNavbar />
            {/* <Navbar /> */}
            {/* <NavbarHome /> */}
            <Routes>
              <Route
                path="/"
                element={
                  <div
                    style={{
                      overflow: "hidden",
                      width: "100vw",
                      height: "100vh",
                    }}
                  >
                    <iframe
                      src="/StaticPages/index.html"
                      style={{
                        width: "100%",
                        height: "100%",
                        border: "none",
                      }}
                      title="Static Page"
                    ></iframe>
                  </div>
                }
              />
              <Route path="/subscription" element={<Subscription />} />
              <Route path="/Plan_selection" element={<Plan_selection />} />
              <Route path="/success" element={<Success />} />
              <Route path="/canceled" element={<Cancelled />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/password-reset-options" element={<PasswordResetOptions />} />
              <Route path="/update-password" element={<UpdatePassword />} />
              <Route path="/clientData" element={<ClientDataMain />} />
              <Route path="/dashtemp" element={<DashboardTemplate />} />
              <Route path="/allEmail" element={<AllEmail />} />
              <Route path="/addSubscriber" element={<AddSubscriber />} />
              <Route path="/manageSubscriber" element={<ManageSubscriber />} />
              <Route path="/subscriberClient" element={<SubscriberClient />} />
              <Route path="/invoiceAdmin" element={<InvoiceAdmin />} />
              <Route path="/supportPage" element={<SupportPage />} />
              <Route path="/feedbackPage" element={<FeedbackPage />} />
              <Route path="/manage-password" element={<ManagePassword />} />
              <Route path="/api/reset-password/verify" element={<ResetPassword />} />
              <Route path="/mainpageSessioNote" element={<MainPage />} />
              <Route path="/SessionNote97151" element={<SessionNote97151 />} />
              <Route path="/SessionNote97153" element={<SessionNote97153 />} />
              <Route path="/SessionNote97155" element={<SessionNote97155 />} />
              <Route path="/SessionNote97156" element={<SessionNote97156 />} />
              <Route path="/SessionNoteH0032" element={<SessionNoteH0032 />} />
              <Route path="/Footer" element={<Footer />} />
              <Route path="/Keywords" element={<Keywords />} />

              {/* <Route path="/adminsessionnote" element={<AdminSessionNote/>} /> */}

              {/* <Route path="/getEmail" element={<GetEmail/>} /> */}

              {/* <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              /> */}
              <Route path="/sessionnote" element={<SessionNotesForm />} />

              <Route
                path="/about-us"
                element={
                  <div
                    style={{
                      overflow: "hidden",
                      width: "100vw",
                      height: "100vh",
                    }}
                  >
                    <iframe
                      src="/StaticPages/aboutus.html"
                      style={{
                        width: "100vw",
                        height: "100vh",
                        border: "none",
                      }}
                    ></iframe>
                  </div>
                }
              />

              <Route
                path="/faqs"
                element={
                  <div
                    style={{
                      overflow: "hidden",
                      width: "100vw",
                      height: "100vh",
                    }}
                  >
                    <iframe
                      src="/StaticPages/faqs.html"
                      style={{
                        width: "100vw",
                        height: "100vh",
                        border: "none",
                      }}
                    ></iframe>
                  </div>
                }
              />
              <Route
                path="/demographics"
                element={
                  <div
                    style={{
                      overflow: "hidden",
                      width: "100vw",
                      height: "100vh",
                    }}
                  >
                    <iframe
                      src="/StaticPages/demographics.html"
                      style={{
                        width: "100vw",
                        height: "100vh",
                        border: "none",
                      }}
                    ></iframe>
                  </div>
                }
              />
              <Route
                path="/feedback"
                element={
                  <div
                    style={{
                      overflow: "hidden",
                      width: "100vw",
                      height: "100vh",
                    }}
                  >
                    <iframe
                      src="/StaticPages/feedback.html"
                      style={{
                        width: "100vw",
                        height: "100vh",
                        border: "none",
                      }}
                    ></iframe>
                  </div>
                }
              />
              <Route
                path="/contact"
                element={
                  <div
                    style={{
                      overflow: "hidden",
                      width: "100vw",
                      height: "100vh",
                    }}
                  >
                    <iframe
                      src="/StaticPages/contactus.html"
                      style={{
                        width: "100vw",
                        height: "100vh",
                        border: "none",
                      }}
                    ></iframe>
                  </div>
                }
              />
              <Route
                path="/support"
                element={
                  <div
                    style={{
                      overflow: "hidden",
                      width: "100vw",
                      height: "100vh",
                    }}
                  >
                    <iframe
                      src="/StaticPages/support.html"
                      style={{
                        width: "100vw",
                        height: "100vh",
                        border: "none",
                      }}
                    ></iframe>
                  </div>
                }
              />

              <Route
                path="/services"
                element={
                  <div
                    style={{
                      overflow: "hidden",
                      width: "100vw",
                      height: "100vh",
                    }}
                  >
                    <iframe
                      src="/StaticPages/services.html"
                      style={{
                        width: "100vw",
                        height: "100vh",
                        border: "none",
                      }}
                    ></iframe>
                  </div>
                }
              />

              <Route
                path="/how-it-works"
                element={
                  <div
                    style={{
                      overflow: "hidden",
                      width: "100vw",
                      height: "100vh",
                    }}
                  >
                    <iframe
                      src="/StaticPages/how-it-works.html"
                      style={{
                        width: "100vw",
                        height: "100vh",
                        border: "none",
                      }}
                    ></iframe>
                  </div>
                }
              />

              <Route
                path="/subs"
                element={
                  <div
                    style={{
                      overflow: "hidden",
                      width: "100vw",
                      height: "100vh",
                    }}
                  >
                    <iframe
                      src="/StaticPages/subs.html"
                      style={{
                        width: "100vw",
                        height: "100vh",
                        border: "none",
                      }}
                    ></iframe>
                  </div>
                }
              />
              <Route
                path="/privacypolicy"
                element={
                  <div
                    style={{
                      overflow: "hidden",
                      width: "100vw",
                      height: "100vh",
                    }}
                  >
                    <iframe
                      src="/StaticPages/privacypolicy.html"
                      style={{
                        width: "100vw",
                        height: "100vh",
                        border: "none",
                      }}
                    ></iframe>
                  </div>
                }
              />
              <Route
                path="/termsandconditions"
                element={
                  <div
                    style={{
                      overflow: "hidden",
                      width: "100vw",
                      height: "100vh",
                    }}
                  >
                    <iframe
                      src="/StaticPages/termsandconditions.html"
                      style={{
                        width: "100vw",
                        height: "100vh",
                        border: "none",
                      }}
                    ></iframe>
                  </div>
                }
              />

              {/* <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          /> */}
              <Route
                path="/subscriberDashboard"
                element={<SubscriberDashboard />}
              />
              <Route
                path="/manageSessionNote"
                element={<ManageSessionNote />}
              />
              <Route path="/manageInvoices" element={<InvoiceTable />} />
            </Routes>
            {/* <Footer /> */}
          </Router>
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert onClose={handleCloseSnackbar} severity="info">
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </SnackbarProvider>
      </LocalizationProvider>
    </AuthProvider>
  );
}

const ConditionalNavbar = () => {
  const location = useLocation();
  const excludedRoutes = [
    "/dashtemp",
    "/login",
    "/register",
    "/forgot-password",
    "/password-reset-options",
    "/api/reset-password/verify",
  ];
  return !excludedRoutes.includes(location.pathname) ? <NavbarHome /> : null;
};

export default App;
